import React, { Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CContainer, CSpinner } from '@coreui/react';
import jwt_decode from 'jwt-decode';
import { getObjectData } from '../services/Storage';

// routes config
import { routes, adminRoutes } from '../routes';
// import {routes,} from '../routes'

const AppContent = () => {
   const [user, setUser] = useState(null);

   useEffect(() => {
      getUserDetails();
   }, []);

   const getUserDetails = async () => {
      try {
         const tokenData = await getObjectData('auth');
         const userData = jwt_decode(tokenData.accessToken);
         if (userData) {
            setUser(userData);
         }
      } catch (error) {
         setUser(null);
      }
   };

   return (
      <CContainer lg>
         <Suspense fallback={<CSpinner color="primary" />}>
            <Routes>
               {user && user.roles.includes('Station Admin')
                  ? adminRoutes.map((route, idx) => {
                       return (
                          route.element && (
                             <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                element={<route.element />}
                             />
                          )
                       );
                    })
                  : routes.map((route, idx) => {
                       return (
                          route.element && (
                             <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                element={<route.element />}
                             />
                          )
                       );
                    })}
               {/* {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })} */}
               <Route path="/" element={<Navigate to="dashboard" replace />} />
            </Routes>
         </Suspense>
      </CContainer>
   );
};

export default React.memo(AppContent);
